<!-- Translated: yes -->
<template>
  <div class="embed-container">
  </div>
</template>

<script>
export default {
  props: ['url'],
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$nextTick(() => {
      let url = this.url;

      if (!url) {
        return;
      }

      // Fix non embeddable Vimeo and Bunny links to embeddable ones
      if (url.includes('vimeo.com')) {
        const vimeoBaseUrl = 'https://player.vimeo.com/video/';
        const vimeoId = url.match(/[0-9]+/);

        url = `${vimeoBaseUrl}${vimeoId}`;
      } else if (url.includes('player.mediadelivery.net')) {
        url = url.replace('/play/', '/embed/');
      }

      const ifrm = document.createElement('iframe');
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('border', '0');
      ifrm.setAttribute('frameborder', '0');

      // Allow fullscreen for both webkit and moz browsers
      ifrm.setAttribute('webkitAllowFullScreen', '');
      ifrm.setAttribute('mozallowfullscreen', '');
      ifrm.setAttribute('allowFullScreen', '');
      ifrm.setAttribute('allow', 'fullscreen');

      this.$el.appendChild(ifrm);
      // this.$el.innerHTML = `<iframe :src='${this.url}'
      // frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`;
    });
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Vimeo.vue?ec6d0412